import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap"
import { useHistory } from "react-router-dom"

const DuplicateTable = ({ data }) => {
  console.log("data", data)
  return (
    <Table className="text-center">
      <tr>
        <th>Reference No</th>
        <th>Policy No</th>
        <th>Survey No</th>
      </tr>
      {data.map((item, i) => (
        <tr key={i}>
          <td>{item.ReferenceNo}</td>
          <td>{item.PolicyNo}</td>
          <td>{item.ArealDecisionNumber}</td>
        </tr>
      ))}
    </Table>
  )
}

const InsertedDataResult = ({
  insertedDataResultToggle,
  setAuth,
  insertedDataResult,
  setInsertedDataResult,
  insertedDataResultType,
  setInsertedDataResultType,
}) => {
  const history = useHistory()

  const [modal, setmodal] = useState(true)
  const modalToggle = () => {
    insertedDataResultToggle()
    setInsertedDataResultType(null)
    setInsertedDataResult(null)
  }
  const onClose = () => {
    insertedDataResultToggle()
    setInsertedDataResultType(null)
    setInsertedDataResult(null)
  }

  // ***************************** Accordion *************************************
  const [open, setOpen] = useState("")
  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  return (
    <Modal isOpen={modal} toggle={modalToggle} className="modal-lg">
      <ModalHeader>
        Inserted Data Duplicates
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        {insertedDataResultType === "file" ? (
          // <div>
          //   {insertedDataResult.map((result, i) => (
          //     <DuplicateTable key={i} data={result.duplicates} />
          //   ))}
          // </div>
          <div>
            <Accordion flush open={open} toggle={toggle}>
              {insertedDataResult.map((item, i) => (
                <AccordionItem key={i}>
                  <AccordionHeader targetId={`duplicate-${i}`}>
                    {/* <Row style={{ width: "100%" }}>
                      <Col>Policy No: {item.duplicates[0].PolicyNo}</Col>
                      <Col>
                        Survey No: {item.duplicates[0].ArealDecisionNumber}
                      </Col>
                    </Row> */}

                    <Table className="text-center">
                      <tr>
                        <th>Policy No:</th>
                        <td className="d-flex justify-content-start">
                          {item.duplicates[0].PolicyNo}
                        </td>
                        <th>Survey No:</th>
                        <td className="d-flex justify-content-start">
                          {item.duplicates[0].ArealDecisionNumber}
                        </td>
                      </tr>
                    </Table>
                  </AccordionHeader>

                  <AccordionBody accordionId={`duplicate-${i}`}>
                    <DuplicateTable data={item.duplicates} />
                    {/* <Table className="text-center">
                      <thead>
                        <th>#</th>
                        <th>Req No</th>
                        <th>last status</th>
                        <th>current status</th>
                        <th>Date</th>
                      </thead>
                      <tbody>
                        {result.results.map((item, index) => (
                          <tr key={index}>
                            <td>{item.HID}</td>
                            <td>{item.RequestID}</td>
                            <td>{item.LastStatus}</td>
                            <td>{item.Status}</td>
                            <td>{item.Date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table> */}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ) : (
          <DuplicateTable data={insertedDataResult} />
        )}

        {/* <Row className="mb-3">
          <Col sm={12} className="d-flex justify-content-end">
            <Button type="submit">Submit</Button>
          </Col>
        </Row> */}
      </ModalBody>
    </Modal>
  )
}

export default InsertedDataResult
